import styled from 'styled-components';

import Color from '../../styles/color';

interface ColorsProps {
  primary?: boolean;
}

interface ImageSize {
  width: number;
  height: number;
}

const Container = styled.div`
  text-align: center;
`;

const IconImage = styled.img`
  margin-top: 25px;
  width: ${(props: ImageSize) => props.width}px;
  height: ${(props: ImageSize) => props.height}px;
`;

const IconTitle = styled.h2`
  color: ${(props: ColorsProps) =>
    props.primary ? Color.primary : Color.neutral};
  text-align: center;
  margin-top: 15px;
  padding: 0 20px;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
`;

export { Container, IconImage, IconTitle };
